import './Footer.css'

const Footer = () => (
  <footer className='footer'>
  <hr className='footer__line'/>
    ©2026 All rights reserved - Memona Amir
  </footer>
)

export default Footer
